import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ts-auto-mock/ts-auto-mock/ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "create-mock-list"
    }}>{`Create mock list`}</h1>
    <p><inlineCode parentName="p">{`createMockList`}</inlineCode>{` creates an array of mocks, so you don't have to do that tedious part yourself.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createMockList } from 'ts-auto-mock';

interface Person {
  id: string;
}
const mockList = createMockList<Person>(2);
mockList.length // 2
`}</code></pre>
    <h2 {...{
      "id": "property-overrides"
    }}>{`Property overrides`}</h2>
    <p>{`You can supply a function as the second argument to override specific properties.`}</p>
    <p>{`The function will be supplied the index of the individual element as the callback argument, e.g.:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { createMockList } from 'ts-auto-mock';

interface Person {
  id: string;
}
const mockList = createMockList<Person>(2, (index: number) => {
    return {
        id: "id" + index
    };
});
mockList[0].id // id0
mockList[1].id // id1
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      